export default {
  name: 'marking--nkGoodsH',
  apiService: 'shoes',
  apiPath: '/admin/nk_goods_h',
  enums: {
    goodDetailedStatus: [
      'DRAFT', 'MODERATION', 'ERRORS', 'NOTSIGNED', 'PUBLISHED',
    ],
  }
};